'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // this changes the number of people and checks is there capacity to do so. Can't be used with day capacity, only with "pakettimatka"

// Needs to be redone. Currently bodged together with winresDeparturesSearch & winresDeparturesList. searchReservableItems request should be here
// and used the Capacity.IsEnough boolean to find is there enough capacity.

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationNoOfPeople = function () {
    function WinresReservationNoOfPeople($scope, $filter, $sce) {
        _classCallCheck(this, WinresReservationNoOfPeople);

        this.$scope = $scope;
        this.$filter = $filter;
        this.$sce = $sce;
        this.blocks = [];
    }

    _createClass(WinresReservationNoOfPeople, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Destination

            this.data = this.winresReservationContext.getContext();
            this.$scope.$watch('$ctrl.data.Destination', function () {
                if (!_this.data.Destination) {
                    return;
                }

                _this.blocks = _.cloneDeep(_this.data.Destination.WebSiteInformationBlocks);

                _this.blocks.forEach(function (block) {
                    return block.Text = _this.$filter('linky')(block.Text).replaceAll("&#10;", "</p><p>");
                });
            });
        }
    }]);

    return WinresReservationNoOfPeople;
}();

WinresReservationNoOfPeople.$inject = ['$scope', '$filter', '$sce'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'noOfPeople-default';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('noOfPeople-default', require('./winresReservationNoOfPeople.html'));
}]);

_module3.default.component('winresReservationNoOfPeople', {
    templateUrl: getTemplate,
    controller: WinresReservationNoOfPeople,
    bindings: {
        reservationLinkTemplate: '@'
    },
    require: {
        winresReservationContext: '^^winresReservationContext',
        winresReservationShoppingTabs: '^^winresReservationShoppingTabs'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationNoOfPeople/winresReservationNoOfPeople.js
// module id = 427
// module chunks = 2